module.exports = __webpack_public_path__ + "static/media/Grey-Ghost-Best.8853081e.jpg";